import React from 'react';

const Vision = ({ sectionTitle, title, spanTitle, description, image }) => {
  return (
    <section className="bg-white dark:bg-slate-950 py-12">
      <div className="container mx-auto flex flex-col lg:flex-row items-center px-6 lg:px-20">
        
        {/* Texte de la bannière */}
        <div className="lg:w-1/2 text-center lg:text-left mb-10 lg:mb-0 mr-6">
          <h6 className="text-xl font-bold text-blue-600 mb-4">{sectionTitle}</h6>
          <h1 className="text-5xl font-bold text-gray-800 dark:text-gray-200 mb-4">
            {title} <span className="text-blue-600">{spanTitle}</span>
          </h1>
          <p className="text-gray-600 dark:text-gray-400 text-lg mb-6">
            {description}
          </p>
        </div>

        {/* Illustration de la bannière */}
        <div className="lg:w-1/2 w-full h-auto px-6">
          <img 
            src={image} 
            alt={sectionTitle}
            className="w-full h-auto object-cover rounded-lg shadow-lg"
          />
        </div>
      </div>
    </section>
  );
};

export default Vision;
